/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface LinkedCompany
 */
export interface LinkedCompany {
    /**
     * 
     * @type {string}
     * @memberof LinkedCompany
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedCompany
     */
    companyName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedCompany
     */
    isCurrentCompany: boolean;
    /**
     * 
     * @type {Currency}
     * @memberof LinkedCompany
     */
    currency: Currency;
}



/**
 * Check if a given object implements the LinkedCompany interface.
 */
export function instanceOfLinkedCompany(value: object): value is LinkedCompany {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('isCurrentCompany' in value) || value['isCurrentCompany'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function LinkedCompanyFromJSON(json: any): LinkedCompany {
    return LinkedCompanyFromJSONTyped(json, false);
}

export function LinkedCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkedCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'isCurrentCompany': json['isCurrentCompany'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

  export function LinkedCompanyToJSON(json: any): LinkedCompany {
      return LinkedCompanyToJSONTyped(json, false);
  }

  export function LinkedCompanyToJSONTyped(value?: LinkedCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'isCurrentCompany': value['isCurrentCompany'],
        'currency': CurrencyToJSON(value['currency']),
    };
}

